import reactquiz from "../images/react-quiz.png";
import pop from "../images/usepopcorn.png";
import corp3 from "../images/corp3.png";
import blog from "../images/blog.png";

const explorationsData = [
  { id: 1, image: reactquiz, title: "The React Quiz" },
  { id: 2, image: pop, title: "usePopcorn" },
  { id: 3, image: blog, title: "The Atomic Blog" },
  { id: 4, image: corp3, title: "SocioPedia" },
];
export default explorationsData;
